enum DealStructure {
  VNEM = 'VNEM',
  FiT = 'FiT',
  CommunitySolar = 'Community Solar',
  NEM_NEMA = 'NEM/NEMA',
  OtherFTMSolar = 'Other Front of the Meter Solar',
}

export default DealStructure;
